<template>
  <v-card
  :disabled="playlistBulbSettingsKey !== 2"
  flat
  height="100%"
  tile
  :ripple="false"
  id="playlistBulbSettingsCard">
    <v-list
    :color="playlistColor"
    height="65"
    dark
    flat
    tile>
      <v-list-item :color="playlistColor">
        <v-list-item-avatar>
          <v-btn
            icon
            @click="closeSlideout()"
            aria-label="Close bulb settings slide out">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>Bulb settings for: {{ bulb.bulbName }}
            <v-icon class="ml-2 bulbSettingsIcon">mdi-pencil</v-icon>
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
    <PlaypositBulbSettings
      ref="bulbPlaylistSettings"
      :key="playlistBulbSettingsKey"
      :wrapper-size="800"
      :bulb="bulb.bulb"
      :module-bulb="moduleBulb"
      :modes="[]"
      :tags="tags"
      :school-listed="school ? school.listed : false"
      :active-color="playlistColor ? playlistColor : '#2196F3'"
      :save-bulb-settings="saveBulbSettings"
      :school="school"
      :permission-keys="school && school.permissionKeys ? school.permissionKeys : []"
      :points-available="pointsAvailable"
      :user-type="bulbSettingsUserType"
      service="playlist"
      :api-url="serverURL"
      :token="userToken"
      :timezone="userTimezone"
      @cancel="closeSlideout()"
      @scorethreshold-playlist-save="handleScoreThresholdPlaylistSave($event)"
    />
    <div id="playlistBulbSettingsPartyTime"></div>
  </v-card>
</template>

<script>
import {
  mapState,
  mapMutations,
  mapActions,
} from 'vuex';


// Plugins / Libraries
import _ from 'lodash';
import moment from 'moment-timezone';
import party from 'party-js';

export default {
  name: 'PlaylistBulbSettings',
  props: [
    'open',
  ],
  data() {
    return {
      playlistBulbSettingsKey: 0,
      serverURL: this.$getServerUrl(),
    };
  },
  computed: {
    ...mapState([
      'playlist',
      'slideoutData',
      'user',
      'userToken',
      'tags',
    ]),
    playlistColor() {
      return _.get(this.playlist, 'default_color', '#2196F3');
    },
    bulb() {
      return {
        bulb: _.get(this, 'slideoutData.bulb', {}),
        bulbName: _.get(this, 'slideoutData.bulb.name', ''),
      };
    },
    moduleBulb() {
      return _.get(this, 'slideoutData.module', {});
    },
    bulbSettingsUserType() {
      return 'schoolTeacher';
    },
    pointsAvailable() {
      return _.get(this, 'slideoutData.pointsAvailable', 0);
    },
    school() {
      return _.get(this, 'playlist.school', {});
    },
    userTimezone() {
      return _.get(this, 'user.userInfo.time_zone', moment.tz.guess());
    },
  },
  methods: {
    ...mapMutations([
      'setSlideout',
    ]),
    ...mapActions([
      'getTags',
      'fetchPlaylistBulbTags',
      'updateItem',
      'updateBulbSettings',
    ]),
    closeSlideout() {
      this.playlistBulbSettingsKey = 0;
      setTimeout(() => {
        this.setSlideout(null);
      }, 500);
    },
    handleScoreThresholdPlaylistSave(data) {
      return this.slideoutData?.handlePlaylistBulbScoreThreshold(data);
    },
    async saveBulbSettings(bulb) { // eslint-disable-line
      await this.updateBulbSettings(bulb);
      await this.fetchPlaylistBulbTags(bulb);
      this.closeSlideout();
      return bulb;
    },
    initializePartyTime() {
      const invocationMethod = (Math.random() > 0.5) ? 'sparkles' : 'confetti';
      party[invocationMethod](document.getElementById('playlistBulbSettingsPartyTime'), { // eslint-disable-line
        count: party.variation.range(0, 100),
        size: party.variation.range(0.6, 1.4),
      });
    },
  },
  watch: {
    async open(newValue) {
      if (
        newValue
        && this.slideoutData.type === 'playlistBulbSettings'
      ) {
        const partyTime = Math.random() <= 0.01;
        this.playlistBulbSettingsKey += 1;
        await this.getTags();
        await this.fetchPlaylistBulbTags(this.bulb.bulb);
        this.playlistBulbSettingsKey += 1;
        if (partyTime) this.initializePartyTime();
      }
    },
  },
};
</script>

<style lang="scss">
  .v-list {
    border-radius: 0 !important;
  }
  .full-width {
    width: 100% !important;
  }

  .row-space {
    width: 100%;
    height: 100%;
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: space-between;
    padding: 16px
  }

  #playlistBulbSettingsPartyTime {
    margin-top: 150px;
    width: 100px;
    height: 100px;
  }

  // Common styling for our toast
  @import '@mixins/Toast/styles.scss';
</style>
